module.exports = __webpack_public_path__ + "static/img/001.1567302.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-gejiachecun/001.png
// module id = i9CK
// module chunks = 1